export enum VoucherTemplate {
  ACCESS = 'voucher.acesso',
  EXCHANGE = 'voucher.troca',
}

export const VoucherTemplateLabels = {
  [VoucherTemplate.ACCESS]: 'Voucher de Acesso',
  [VoucherTemplate.EXCHANGE]: 'Voucher de Troca',
}
